import { Icon } from '@shared/ui';
import { EAttendanceStatusMap, IAttendanceStatus } from '@shared/types';
import styled from 'styled-components';

const StyledContainer = styled.div<{ $color: string; $backgroundColor: string }>`
  display: flex;
  gap: 0.25rem;
  border: none;
  border-radius: 10px;
  padding: 4px 8px;
  width: fit-content;
  font-size: 0.875rem;

  background-color: ${props => props.$backgroundColor};
  color: ${props => props.$color};
`;

export const AttendanceStatusBadge = ({ status }: { status: IAttendanceStatus }) => {
  const { icon: Component, backgroundColor, color, text } = EAttendanceStatusMap[status];

  return (
    <StyledContainer $color={color} $backgroundColor={backgroundColor}>
      <Icon>
        <Component weight='fill' />
      </Icon>
      {text}
    </StyledContainer>
  );
};
